<template>
  <div class="overlay-loader" v-if="visible">
    <div class="spinner"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'OverlayLoader',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  }
});
</script>

<style scoped>
.overlay-loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 4px solid #ccc;
  border-top: 4px solid #605dff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>